__turbopack_context__.v({
  "root": "CarouselButton-module__0nOLha__root",
});
